import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { B2cPresenceResponse, CurrencyTrendResponse, OilHistoryResponse } from 'src/typings';

@Injectable({ providedIn: 'root' })
export class HeaderCurrencyService {
  constructor(private http: HttpClient) {}

  getTrend() {
    return this.http.get<CurrencyTrendResponse>(`${environment.BACKEND}/currency/trend`);
  }

  getOilHistory(days: number) {
    return this.http.get<OilHistoryResponse>(
      `${environment.BACKEND}/currency/oil/history?benchmark=BRENT&days=${days}`
    );
  }

  getB2cPresence() {
    return this.http.get<B2cPresenceResponse>(`${environment.BACKEND}/public/b2c/presence/online`);
  }
}
